var _defs, _circle, _polyline, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    strokeWidth: 1,
    width: 29,
    height: 29,
    color: "#FFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-6374f8d9b67f094e4896c63c-1{fill:none;stroke:currentColor;stroke-miterlimit:10;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6374f8d9b67f094e4896c63c-1",
    cx: 12,
    cy: 12,
    r: 10.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6374f8d9b67f094e4896c63c-1",
    points: "12 16.77 12 10.09 10.09 10.09"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-6374f8d9b67f094e4896c63c-1",
    x1: 10.09,
    y1: 16.77,
    x2: 13.91,
    y2: 16.77
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6374f8d9b67f094e4896c63c-1",
    x1: 11.05,
    y1: 7.23,
    x2: 12.95,
    y2: 7.23
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.67cbc832809cdabac5fdb690bfa3847a.svg";
export { ForwardRef as ReactComponent };